/**
 * For-Who — "Cost Leak Meter" section content.
 *
 * The rendered section pairs a live ticker (top), a lede, three persona
 * "slabs" each anchored on a before/after hero number, and a foot CTA.
 *
 * Each card describes three shapes of figure:
 *   1. currency: `$<beforeNum>k → $<afterNum>k`        (Scaling founders)
 *   2. currency-to-text: `$<beforeNum>k → <afterText>` (Operations leaders)
 *   3. label-percent: `Adoptee · 15% → Adoption · 85%+`(Enterprise teams)
 */

export const forWhoHead = {
  eyebrow: 'Who this is for',
  heading: 'Built for operators who have *outgrown* the manual way.', // asterisks wrap the word that gets the purple→blue gradient
  description:
    'If your team is spending more time on process than on the work that actually grows the business, or your AI investment is stalling at the adoption stage, this is for you.',
};

export const forWhoMeter = {
  label: 'Leak meter · while you read this',
  unit: 'burned',
  note: 'Aggregate of typical operator leaks below. Real-time simulation.',
  // Rate used by the live ticker: $110k / year accelerated ×60.
  annualDollars: 110000,
  speedup: 60,
};

export const forWhoFoot = {
  line: 'If any of those numbers look familiar, the leak is fixable.',
  button: 'Stop the leak',
};

export const forWhoCards = [
  {
    id: 'scaling-founders',
    title: 'Scaling founders',
    kind: 'currency',
    trigger: 'Your team spends $60k a year on work a system could do for $10k.',
    restBody: 'Your team spends $?? a year on work a system could do for $??.',
    beforeLabel: '$',
    beforeNum: 60,
    beforeUnit: 'k',
    afterLabel: '$',
    afterNum: 10,
    afterUnit: 'k',
    subBefore: 'year today',
    subAfter: 'year with systems',
    body: 'You have proven the business model. Now the growth is jammed behind admin your best people should not be doing. Systems take the repetitive load and hand the hours back to the client work, the deals, and the relationships that compound.',
  },
  {
    id: 'operations-leaders',
    title: 'Operations leaders',
    kind: 'currency-to-text',
    trigger: 'Manual handoffs are costing you $15k in lost time every quarter.',
    restBody: 'Manual handoffs are costing you $?? in lost time every quarter.',
    beforeLabel: '$',
    beforeNum: 15,
    beforeUnit: 'k',
    afterText: 'Zero',
    subBefore: 'quarter today',
    subAfter: 'with systems',
    body: 'Your workflows are sound but the execution is manual. Reconciliation, routing, follow-ups, reporting. All of it could run itself, with your people approving the judgement calls instead of doing the data entry.',
  },
  {
    id: 'enterprise-teams',
    title: 'Enterprise teams',
    kind: 'label-percent',
    trigger: 'You bought the tools. Adoption is stuck at 15%.',
    restBody: 'You bought the tools. Adoption is stuck at --%.',
    labelBefore: 'Adoption',
    labelRest: 'Adoptee',
    beforeNum: 15,
    beforeUnit: '%',
    labelAfter: 'Adoption',
    afterNum: 85,
    afterUnit: '%+',
    subBefore: 'today',
    subAfter: 'with systems',
    body: 'The AI investment is made. The capability is not. Your teams need structured enablement applied to their real processes. Not another licence. Not another vendor demo.',
  },
];
